import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-normalized-metrics',
  templateUrl: './help-normalized-metrics.component.html',
  styleUrls: ['./help-normalized-metrics.component.scss']
})
export class HelpNormalizedMetricsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
